import React, { PureComponent } from 'react';
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from 'recharts';
import {durationToString} from "../../utils/date";

const COLORS = [
  {
    name: 'Fab',
    color: '#0088FE',
  },
  {
    name: 'Prep',
    color: '#00C49F',
  },
  {
    name: 'S/B',
    color: '#FFBB28',
  },
  {
    name: 'Powder',
    color: '#FF8042',
  },
  {
    name: 'Liner',
    color: '#d9bd11',
  },
  {
    name: 'Zinc',
    color: '#6ba353',
  },
  {
    name: 'Prime',
    color: '#1c6599',
  },
  {
    name: 'Body',
    color: '#ce1631',
  },
  {
    name: 'Paint',
    color: '#b384e2',
  },
  {
    name: 'Detail',
    color: '#95dc11',
  },
];

const findColor = (name) => {
  const color = COLORS.find(color => color.name === name);
  if (!color) {
    return '#ff0000';
  }
  return color.color;
}

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius,
                                 outerRadius, percent, index, value, name }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white"
          textAnchor={x > cx ? 'start' : 'end'}
          dominantBaseline="central">
        {`${name}`}: {`${durationToString(value)}`}
    </text>
  );

};

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;

  console.log('payload', payload);
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fontSize={20} fill={"#333"}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`Time spent: ${durationToString(value)}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

export default class PieChartWithCustomizedLabel extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.data.length > 0 && nextProps.data.length === 0) {
      return true;
    }

    if (nextProps.data.length === 0) {
      return false;
    }

    return true;
  }

  onPieEnter = (_, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  render() {

    if (this.props.data.length === 0) {
      return null;
    }

    return (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart width={400} height={400}>
              <Pie
                activeIndex={this.state.activeIndex}
                activeShape={renderActiveShape}
                data={this.props.data}
                cx="50%"
                cy="50%"
                innerRadius={100}
                outerRadius={140}
                dataKey="value"
                onMouseEnter={this.onPieEnter}
              >  {this.props.data.map((entry, index) => (
                  <Cell key={`cell-${index}`}  fill={findColor(entry.name)} />
               ))}
            </Pie>
            </PieChart>
          </ResponsiveContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/PieChartWithCustomizedLabel/index.js